<template>
  <div class="px-[19px] h-full">
    <div
      class="flex items-center text-[11px] color-[#ffffff] justify-between overflow-hidden header-container px-[8px]">
      <div class="flex items-center flex-1 min-w-0 font-bold">
        <span :class="getTomorrowTextClass()" class="truncate">{{ t('rebate.canCollectToday') }}</span>
        <span class="color-[#FFED00] ml-[5px] whitespace-nowrap flex-shrink-0">{{
          formatAmount(userAntiWater?.todayReward) || 0 }}</span>
      </div>
      <div class="flex items-center flex-1 min-w-0 ml-[8px] font-bold">
        <span :class="getTomorrowTextClass()" class="truncate">{{ t('rebate.availableTomorrow') }}</span>
        <span class="color-[#FFED00] ml-[5px] whitespace-nowrap flex-shrink-0">{{
          formatAmount(userAntiWater?.tomorrowReward) || 0 }}</span>
      </div>
    </div>
    <div class="flex mt-[13px]  h-[calc(100%-40px)]">
      <div class="flex-shrink-0 pt-[14px] -mr-[1px]">
        <div v-for="(item, index) in rebateList" :key="index" class="flex justify-end ">
          <div class="csjesr flex justify-end" :class="{ 'active font-bold': selectedIndex === index }"
            @click="selectItem(index)">
            <img :src="selectedIndex === index ? item.activeImage : item.image" alt=""
              class="w-[26.5px] h-[26.5px] mt-[8px]" style="object-fit: contain;">
            <div class="text-[12px] mt-[2px] " :class="selectedIndex === index ? 'color-[#ffffff]' : 'color-[#92CCCB]'">
              {{ item.titleKey }}
            </div>
          </div>

        </div>
        <div class="recebers-container">
          <Button type="small" :disabled="!canReceive" @click="receivePrizes">
            {{ t('rebate.receive') }}
          </Button>
        </div>
        <Button type="small" @click="toHistory">
          {{ t('rebate.history') }}
        </Button>

      </div>
      <div class="flex-1 min-w-0 content-container py-[15px] px-[7px] h-full">

        <div>
          <!-- 供应商列表循环渲染 -->
          <div v-for="(vendor, index) in currentVendorList" :key="`${selectedIndex}-${index}`"
            class="cabgdata mb-[10px]" @click="selectVendor(vendor)">
            <div class="flex-1 min-w-0">
              <div class="flex items-center justify-between font-bold">
                <div class="flex items-center justify-between w-1/2">
                  <img :src="vendor.icon ? VITE_IMG_URL + vendor.icon : getAssetsFile('home/zu15.png')" alt=""
                    class="w-[18px] h-auto flex-shrink-0" :class="vendor.icon ? 'svg-color' : ''" />
                  <div class="text-[#002421] w-full text-center text-[10px] font-bold">
                    {{ t('rebate.validBets') }}
                  </div>


                  <!-- <div class="color-[#60B289] ml-[10px] text-[9px] truncate">{{ t('rebate.validBets') }}</div> -->
                </div>
                <div class="flex items-center flex-shrink-0">
                  <div class="color-[#ffffff] text-[10px]">{{ vendor.betAmount }}</div>
                  <div class="color-[#002421] ml-[10px] text-[10px] font-bold">
                    <!-- Taxa de reembolso -->
                    {{ t('rebate.rebateRate') }}
                  </div>
                  <div class="color-[#ffffff] text-[10px] ml-[7px] font-bold">{{ formatPercentage(vendor.antiWaterRatio)
                  }}%</div>
                </div>
              </div>
              <div class="flex items-center mt-[7px]  ">
                <div class="proseees flex-1 min-w-0">
                  <span class="truncate block font-bold text-[9px]">
                    {{ t('rebate.betToGet', {
                      amount: formatAmount(vendor.upLevelBetAmount),
                      rate: formatPercentage(vendor.nextBetRatio)
                    }) }}
                  </span>
                </div>
                <div class="color-[##002421] ml-[3px] text-[10px] flex-shrink-0 font-bold">{{ t('rebate.collectible') }}
                </div>
                <div class="color-[#F6FF00] ml-[6px] text-[10px] flex-shrink-0 font-bold">{{
                  formatAmount(vendor.realTimeAmount)
                }}
                </div>
              </div>
            </div>
            <img :src="getAssetsFile('activity/xiangyos.png')" alt="" class="w-[6px] h-[10px] ml-[7px] flex-shrink-0"
              style="object-fit: contain;" />
          </div>
        </div>
      </div>
    </div>

    <!-- 奖励弹窗 -->
    <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import * as GameApi from '@/api/game';
import useUIStore from '@/stores/modules/ui';
import { getAssetsFile } from '@/utils/pub-use';
import RewardDialog from '@/components/RewardDialog.vue'; // 添加这行导入
import { numberFormat } from '@/utils/formatter';
import { Button } from '@/components/Button';

const { t } = useI18n();

const VITE_IMG_URL = import.meta.env.VITE_IMG_URL
const router = useRouter();
const uiStore = useUIStore();

const selectedIndex = ref(1); // 将 0 改为 1，默认选中 slot 类型
const canReceive = ref(false)

// 添加弹窗相关状态
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

// 基础类型配置
const baseRebateList = [
  { titleKey: 'cards', image: getAssetsFile('game/gameTypeCard.png'), activeImage: getAssetsFile('game/gameTypeCardActive.png'), type: 'CHESS' },
  { titleKey: 'slot', image: getAssetsFile('game/gameTypeSlot.png'), activeImage: getAssetsFile('game/gameTypeSlotActive.png'), type: 'SLOTS' },
  { titleKey: 'fishing', image: getAssetsFile('game/gameTypeFish.png'), activeImage: getAssetsFile('game/FISHING_on.png'), type: 'FISH' },
  { titleKey: 'live', image: getAssetsFile('game/gameTypeLive.png'), activeImage: getAssetsFile('game/VIDEO_on.png'), type: 'LIVE' },
  { titleKey: 'arcades', image: getAssetsFile('game/gameTypeArcades.png'), activeImage: getAssetsFile('game/jieJi.png'), type: 'ARCADES' }
];



// 动态生成的类型列表
const rebateList = ref([]);

// 类型与接口字段的映射
const vendorTypeMap = ['CHESS', 'SLOTS', 'FISH', 'LIVE', 'ARCADES'];

// 使用 any 类型解决 TypeScript 错误
const userAntiWater = ref<any>({});
const vendorDataList = ref<any>({});

// 当前选中的供应商数组
const currentVendorList = computed(() => {
  if (rebateList.value.length === 0) return [];
  const selectedItem = rebateList.value[selectedIndex.value];
  if (!selectedItem) return [];
  const typeKey = selectedItem.type;
  const vendors = vendorDataList.value[typeKey] || [];
  return vendors;
});

// 根据vendorDataList动态生成rebateList
const generateRebateList = () => {
  const filteredList = baseRebateList.filter(item => {
    const vendors = vendorDataList.value[item.type] || [];
    return vendors.length > 0; // 只显示有数据的类型
  });
  rebateList.value = filteredList;

  // 如果当前选中的索引超出范围，重置为0
  if (selectedIndex.value >= filteredList.length) {
    selectedIndex.value = 0;
  }
};

const selectItem = (index: number) => {
  selectedIndex.value = index;
};

const selectVendor = (vendor: any) => {
  router.push({
    path: '/activity/components/activityIndex/reembolso',
    query: {
      vendorId: vendor.vendorId,
      gameType: vendor.gameType // 添加第二个参数
    }
  })
}

const formatAmount = (val: number) => {
  if (val == null) return '0,00';
  return numberFormat(val, { minDecimals: 2 });
};

// 新增格式化百分比函数
const formatPercentage = (val: number) => {
  if (val == null) return '0,00';
  return numberFormat(Number(val) * 100, { minDecimals: 2 });
};

const toHistory = () => {

  // 先检查当前路由
  const currentTab = router.currentRoute.value.query.tab

  if (currentTab === 'historico') {
    return
  }

  // 强制跳转并刷新
  router.replace('/activity?tab=historico').then(() => {
  })
}

// 更新返利红点状态
const updateRebateBadge = () => {
  const hasRewards = userAntiWater.value.todayReward > 0
  uiStore.setActivityBadge('rebate', hasRewards)
}

// 监听返利数据变化，更新红点状态
watch(() => userAntiWater.value.todayReward, () => {
  updateRebateBadge()
})

onMounted(async () => {
  try {
    const res = await GameApi.getUserAntiWater();
    userAntiWater.value = res.data;
    vendorDataList.value = res.data.vendorDataList || {};

    // 根据vendorDataList动态生成rebateList
    generateRebateList();

    if (userAntiWater.value.todayReward > 0) {
      canReceive.value = true
    }
    // 更新返利红点状态
    updateRebateBadge()
  } catch (error) {
  }
});

const receivePrizes = async () => {
  const res = await GameApi.receivePrize();

  // 直接显示奖励弹窗，传递领取的金额
  rewardAmount.value = res.data
  showRewardDialog.value = true



};

// 添加处理奖励确认函数
const handleRewardConfirm = async () => {
  // 弹窗关闭后的处理逻辑
  console.log('返利奖励已确认')

  // 等待一下确保API处理完成
  await new Promise(resolve => setTimeout(resolve, 500))

  // 重新获取数据并更新红点状态
  try {
    const newRes = await GameApi.getUserAntiWater();
    userAntiWater.value = newRes.data;
    vendorDataList.value = newRes.data.vendorDataList || {};

    // 根据新的vendorDataList重新生成rebateList
    generateRebateList();

    canReceive.value = newRes.data.todayReward > 0;
    updateRebateBadge();
  } catch (error) {
    console.error('刷新数据失败:', error);
  }
};

// 根据明天奖励金额动态调整字体大小
const getTomorrowTextClass = () => {
  const amount = userAntiWater.value?.tomorrowReward || 0
  const amountStr = formatAmount(amount)

  // 根据数字长度调整字体大小
  if (amountStr.length > 10) {
    return 'text-[8px]' // 数字很长时，文字更小
  } else if (amountStr.length > 7) {
    return 'text-[9px]' // 数字较长时，文字稍小
  } else {
    return 'text-[11px]' // 默认大小
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  background: getPath('activity/rebateHeaderBg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 30px;
}

.content-container {
  background: getPath('activity/rebateContentBg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 100%;
}

.svg-color {
  filter: brightness(0) invert(1) brightness(1.2) !important;
  -webkit-filter: brightness(0) invert(1) brightness(1.2) !important;
  -moz-filter: brightness(0) invert(1) brightness(1.2) !important;
  -ms-filter: brightness(0) invert(1) brightness(1.2) !important;
}

.csjesr {
  width: 48px;
  text-align: center;
  background: getPath('activity/receberVendorItemBg.png') no-repeat center center;
  background-size: 100% 100%;
  // border-radius: 6px;
  height: 65px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.csjesr::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: rgba(0, 0, 0, 0);

  pointer-events: none;
  // transition: background 0.3s ease;
}

.csjesr:not(.active):hover::before {
  background: #004D37;
  opacity: 0.5;
  border-radius: 12px;
}

.csjesr.active {
  width: 54px;
  background: getPath('activity/receberVendorItemActiveBg.png') no-repeat center center;
  background-size: 100% 100%;
  text-shadow: 0px 1px 1px #003A42;
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);

  img {
    width: 28.5px;
    height: 28.5px;
  }
}

/* 确保所有按钮内的图片尺寸一致 */
.csjesr img {

  object-fit: contain !important;
  flex-shrink: 0;
}

/* 只对非激活状态的图片应用绿色滤镜 */
.csjesr:not(.active) img {
  filter: brightness(0) saturate(100%) invert(67%) sepia(11%) saturate(1234%) hue-rotate(118deg) brightness(95%) contrast(87%);
  transition: filter 0.3s ease;
}

/* hover时图片变暗 */
.csjesr:not(.active):hover img {
  filter: brightness(0) saturate(100%) invert(67%) sepia(11%) saturate(1234%) hue-rotate(118deg) brightness(95%) contrast(87%) brightness(0.7);
}

/* 领取按钮容器，防止镜片溢出 */
.recebers-container {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 24px;
  margin-top: 0;
}

/* 不可领取状态 */
.recebers {
  width: 54px;
  height: 24px;
  background: linear-gradient(0deg, #796F22 0%, #7C7A36 100%);
  border-radius: 5px;
  font-weight: bold;
  color: #ABA778;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  z-index: 10;
  overflow: hidden;
}

/* 可领取状态 */
.recebers-active {
  background: #FDAC41 !important;
  color: #FFFFFF !important;
}

/* 镜片滑动动画 */
// .button-shine {
//   position: absolute;
//   top: -50%;
//   left: -100%;
//   width: 100%;
//   height: 200%;
//   background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
//   transform: rotate(45deg);
//   animation: shine 3s infinite;
//   z-index: 2;
//   pointer-events: none;
// }

@keyframes shine {
  0% {
    left: -100%;
    opacity: 0;
  }

  5% {
    opacity: 1;
  }

  25% {
    left: 100%;
    opacity: 1;
  }

  30% {
    left: 100%;
    opacity: 0;
  }

  100% {
    left: 100%;
    opacity: 0;
  }
}

.historico {
  margin-top: 4px;
  width: 54px;
  height: 24px;
  line-height: 24px;
  background: linear-gradient(0deg, #399958 0%, #43C36B 100%);
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #FFFFFF;
  cursor: pointer;
}

.historico:hover {
  color: #9CDAB9;
}

.cabgdata {
  min-height: 48px;
  background: getPath('activity/rebateItemBg.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 9px;
  padding: 8px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  /* 改为100%宽度 */
  max-width: 280px;
  /* 设置最大宽度 */
  flex-shrink: 0;
  /* 防止收缩 */
}

.cabgdata:hover {
  background: #0A5D42;
}

.proseees {
  width: 100%;
  /* 改为100%宽度 */
  max-width: 188px;
  /* 设置最大宽度 */
  height: 10px;
  line-height: 10px;
  background: #002421;
  border-radius: 5px;
  font-size: 9px;
  color: #FFFFFF;
  text-align: center;
  overflow: hidden;
  /* 防止文字溢出 */
}
</style>
